import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

// Função para buscar os usuários

export const buscarUsuarioByIdService = async (usuarioId: number) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
  return []; // Retorna um array vazio se o Token não for válido
};

export {};
